import { useRef } from "react";

import suggestion from "../Nodes/InputVariable/suggestion";

import { usePlayground } from "@/components/Playground/playground-store";

const useDetectedInputVariableSuggestions = (inputVariables?: string[]) => {
  const inputVariablesRef = useRef(inputVariables);
  inputVariablesRef.current = inputVariables;

  try {
    const playground = usePlayground();

    const getVariables = () => inputVariablesRef.current ?? playground.detectedInputVariables;

    return suggestion(getVariables);
  } catch {
    return suggestion(() => inputVariablesRef.current ?? []);
  }
};

export default useDetectedInputVariableSuggestions;
